import { AJOUTE_RESERVATION, SUPRIMER_RESERVATION } from '../types/typeReservation';

export const ajouteReservation = (reservation) => {
    return {
        type: AJOUTE_RESERVATION,
        payload: reservation
    }
}

export const suprimerReservation = () => {
    return {
        type: SUPRIMER_RESERVATION,
        payload: []
    }
}